import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Dashboard } from '../../models/dashboard/dashboard';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import TitleBarNavigation from '../../models/titlebar/titlebar-navigation';

@Component({
  selector: 'seb-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  hideButtonTitlebar: Boolean = true;
  labelTitleModal: String = '';
  titleHeader: TitleBarNavigation[] = [
    { titleBreadcrumb: 'Dashboard', routeNavigation: null }
  ];
  dashboard: Dashboard;
  urlPowerBi: SafeResourceUrl;
  indiceUD: String;

  constructor(private dashService: DashboardService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.dashService.getAllDashboard().subscribe(
      (data: any) => {
        this.dashboard = data;
        this.urlPowerBi = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboard.url);
        this.indiceUD = this.dashboard.title;
      }
    );
  }
}
